import { defineComponent as _defineComponent } from 'vue'
import PublicPortfolioPostsEmptySection from './PublicPortfolioPostsEmptySection/PublicPortfolioPostsEmptySection.vue';
import PublicPortfolioPostsListSection from './PublicPortfolioPostsListSection/PublicPortfolioPostsListSection.vue';

import type { PostConnection } from '~/types/graphql';

type PublicPortfolioPostsSectionProps = {
  posts: PostConnection;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioPostsSection',
  props: {
    posts: null
  },
  setup(__props: any) {



return { __sfc: true,PublicPortfolioPostsEmptySection, PublicPortfolioPostsListSection }
}

})